// B1 Level Aggregator - Intermediate
// Tüm B1 ünite içeriklerini birleştirir

import { B1_UNIT_1 } from './kariyerContentsB1Unit1';
import { B1_UNIT_2 } from './kariyerContentsB1Unit2';
import { B1_UNIT_3 } from './kariyerContentsB1Unit3';
import { B1_UNIT_4 } from './kariyerContentsB1Unit4';
import { B1_UNIT_5 } from './kariyerContentsB1Unit5';
import { B1_FINAL } from './kariyerContentsB1Final';

export const B1_LEVEL = {
  ...B1_UNIT_1,  // Future - Will
  ...B1_UNIT_2,  // Future - Going to
  ...B1_UNIT_3,  // Comparatives & Superlatives
  ...B1_UNIT_4,  // First Conditional
  ...B1_UNIT_5,  // Modal Verbs: Obligation & Advice
  ...B1_FINAL,   // Final Sınavı
};

export default B1_LEVEL;
